/**
 * Single-player Dragon Tiger game-domain types.
 * Ported from packages/amgdragontiger_v2/lib/core/constants/game_constants.dart
 */

export type GamePhase =
  | 'idle'
  | 'initializing'
  | 'modeSelection'
  | 'betting'
  | 'bettingClosed'
  | 'waitingResult'
  | 'cardReveal'
  | 'showResult'
  | 'result'
  | 'newRound'
  | 'error';

export type BetType = 'dragon' | 'tiger' | 'tie';

export const BET_ITEM_ID: Record<BetType, number> = {
  dragon: 262,
  tiger: 263,
  tie: 264,
};

export const PAYOUT: Record<BetType, number> = {
  dragon: 1, // 1:1
  tiger: 1, // 1:1
  tie: 8, // 8:1
};

export function betTypeFromId(id: number): BetType | null {
  switch (id) {
    case 262:
      return 'dragon';
    case 263:
      return 'tiger';
    case 264:
      return 'tie';
    default:
      return null;
  }
}

export type GameResult = 'dragon' | 'tiger' | 'tie';

export const GAME_RESULT_HISTORY_VALUE: Record<GameResult, 1 | 2 | 3> = {
  dragon: 1,
  tiger: 2,
  tie: 3,
};

export function gameResultFromWinningBetId(id: number): GameResult {
  switch (id) {
    case 262:
      return 'dragon';
    case 263:
      return 'tiger';
    case 264:
      return 'tie';
    default:
      throw new Error(`Invalid winning bet ID: ${id}`);
  }
}

export type CardSuit = 'clubs' | 'diamonds' | 'hearts' | 'spades';

export const SUIT_OFFSET: Record<CardSuit, number> = {
  clubs: 0,
  diamonds: 13,
  hearts: 26,
  spades: 39,
};

export interface GameConfig {
  minBet: number;
  maxBet: number;
  chipValues: readonly number[];
}

export interface GameRound {
  roundId: string;
  nextRoundId: string;
  dragonCard: number; // 1..52
  tigerCard: number; // 1..52
  dragonPoint: number; // 1..13
  tigerPoint: number; // 1..13
  result: GameResult;
  totalWinLose: number;
  totalBet: number;
  positiveWinAmount: number;
  hasPositiveWin: boolean;
}
